import { URLShare } from "@/core/api/room.urlshare.api";

export default {
  async createOrUpdateURLShare({dispatch, commit, state}, params) {
    let actionName = 'createURLShare';
    if (params.urlIdx) {
      actionName = 'updateURLShare';
    }
    const res = await dispatch(actionName, params);
    commit('REMOVE_URLSHARE_EDIT_STATE', params);
    return res;
},

  async createURLShare({dispatch, commit, state}, params) {
    const res = await URLShare.createURLShare(params);
    return res;
  },
  async removeURLShare({dispatch, commit, state}, params = {}) {
    const res = await URLShare.removeURLShare(params);
    return res;
  },

  async updateURLShare({dispatch, commit, state}, params = {}) {
    const res = await URLShare.updateURLShare(params);
    return res;
  },

  async getURLShareList({dispatch, commit, state}) {
    const res = await URLShare.getURLShareList();
    commit('SET_URLSHARE_LIST', res.data);
    return res;
  },
  async startURLShareList({dispatch, commit, state}, params) {
    const res = await URLShare.startURLShareList(params);
    return res;

  }
}
